<template>
    <div>
        <div class="mb-4 font-bold">My Invoices</div>
        <div v-for="(invoice, i) in invoices" :key="i">
            <InvoiceEntry :invoice="invoice"></InvoiceEntry>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InvoiceEntry from "../../../components/profile/InvoiceEntry";

export default {
    name: "Index.vue",
    components: { InvoiceEntry },
    computed: mapGetters({ invoices: "profile/invoices/invoices" }),
    methods: mapActions({ fetch: "profile/invoices/fetch" }),
    mounted() {
        this.fetch();
    }
};
</script>

<style scoped></style>
